import PropTypes from "prop-types";
import { useMemo } from "react";

export const AMENITIES = [
  {
    id: "footwear",
    name: "Shoes",
    icon: "footwear"
  },
  {
    id: "likeNew",
    name: "Like New",
    icon: "Like New"
  },
  {
    id: "buyOnlinePickupStore",
    name: "Buy Online Pickup at Store",
    icon: "store"
  },
  {
    id: "complementaryHemming",
    name: "Hemming",
    icon: "Hemming"
  },
  {
    id: "returnsExchanges",
    name: "Returns & Exchanges",
    icon: "Returns & Exchanges"
  }
];

export const storeAmenitiesPropType = PropTypes.shape({
  footwear: PropTypes.bool,
  personalShopping: PropTypes.bool,
  likeNew: PropTypes.bool,
  buyOnlinePickupStore: PropTypes.bool,
  curbsidePickup: PropTypes.bool,
  complementaryHemming: PropTypes.bool,
  returnsExchange: PropTypes.bool
});

export function useAmenities() {
  return useMemo(() => {
    return AMENITIES;
  }, []);
}

export function useCarouselFormattedAmenities(storeAmenities) {
  const allAmenities = useAmenities();

  return allAmenities.map((a) => ({
    ...a,
    isEnabled: storeAmenities[a.id]
  }));
}
